module.exports = __webpack_public_path__ + "assets/img/Latest_new@2x.3335f146.png";